import script from "./index.vue?vue&type=script&lang=ts&setup=true&name=HPagination"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&name=HPagination"

import "./index.vue?vue&type=style&index=0&id=564171be&lang=scss"

const __exports__ = script;

export default __exports__